import styled from 'styled-components';

export const Container = styled.div<{ narrow?: boolean }>`
  width: 100%;
  max-width: ${props => props.narrow ? '800px' : props.theme.breakpoints.xl};
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing[4]};
  position: relative;
  z-index: 1;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    padding: 0 ${props => props.theme.spacing[6]};
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    padding: 0 ${props => props.theme.spacing[8]};
  }
`;

export const Section = styled.section<{ background?: 'primary' | 'secondary' | 'transparent'; $isDark?: boolean }>`
  padding: ${props => props.theme.spacing[16]} 0;
  position: relative;
  overflow: visible;
  background: ${props => {
    const isDark = props.$isDark;
    switch (props.background) {
      case 'primary':
        return isDark ? props.theme.colors.dark.background : props.theme.colors.light.background;
      case 'secondary':
        return isDark ? props.theme.colors.dark.backgroundSecondary : props.theme.colors.light.backgroundSecondary;
      default:
        return 'transparent';
    }
  }};

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    padding: ${props => props.theme.spacing[12]} 0;
  }
`;